<template>
    <div>
        <component
            :is="component"
            v-for="(product, index) in offers"
            :key="product.name"
            :product="product"
            :data-cy="`visa-offer-${index}`"
            :class="contentClass"
            :is-package="isPackage"
        >
            <template v-slot:price="{offer}">
                <slot name="price" :offer="offer" />
            </template>
        </component>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import VisaCard from '~src/components/visa/search/offers/VisaCard.vue'
    import VisaCardMobile from '~src/components/visa/search/offers/VisaCardMobile.vue'

    @Component({
        components: {
            VisaCard,
            VisaCardMobile,
        },
    })
    export class VisaOffers extends Vue {
        @Prop({default: () => []}) offers
        @Prop() contentClass
        @Prop({default: false, type: Boolean}) isPackage

        get component() {
            return this.$breakpoint.smAndDown ? resolveComponent('VisaCardMobile') : resolveComponent('VisaCard')
        }
    }

    export default VisaOffers
</script>
